/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { ExtensibleNode } from '../ExtensibleNode';
import { IReferenceNode } from '../IReferenceNode';
import { IVisitor } from '../../visitors/IVisitor';
import { INamed } from './INamed';
import { Schema } from './Schema';

/**
 * Constructor.
 * @param {string} name
 * @class
 * @extends ExtensibleNode
 * @author eric.wittmann@gmail.com
 */
export abstract class Parameter extends ExtensibleNode implements IReferenceNode, INamed {
    public $ref : string;

    public name : string;

    public description : string;

    public schema : Schema;

    public constructor(name? : any) {
        if(((typeof name === 'string') || name === null)) {
            let __args = arguments;
            super();
            if(this.$ref===undefined) this.$ref = null;
            if(this.name===undefined) this.name = null;
            if(this.description===undefined) this.description = null;
            if(this.schema===undefined) this.schema = null;
            if(this.$ref===undefined) this.$ref = null;
            if(this.name===undefined) this.name = null;
            if(this.description===undefined) this.description = null;
            if(this.schema===undefined) this.schema = null;
            (() => {
                this.name = name;
            })();
        } else if(name === undefined) {
            let __args = arguments;
            super();
            if(this.$ref===undefined) this.$ref = null;
            if(this.name===undefined) this.name = null;
            if(this.description===undefined) this.description = null;
            if(this.schema===undefined) this.schema = null;
            if(this.$ref===undefined) this.$ref = null;
            if(this.name===undefined) this.name = null;
            if(this.description===undefined) this.description = null;
            if(this.schema===undefined) this.schema = null;
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.core.models.Node#accept(io.apicurio.datamodels.core.visitors.IVisitor)
     * @param {*} visitor
     */
    public accept(visitor : IVisitor) {
        visitor.visitParameter(this);
    }

    /**
     * 
     * @return {string}
     */
    public getReference() : string {
        return this.$ref;
    }

    /**
     * 
     * @param {string} reference
     */
    public setReference(reference : string) {
        this.$ref = reference;
    }

    public abstract createSchema() : Schema;

    /**
     * @see io.apicurio.datamodels.core.models.common.INamed#getName()
     * @return {string}
     */
    public getName() : string {
        return this.name;
    }

    /**
     * @see io.apicurio.datamodels.core.models.common.INamed#rename(java.lang.String)
     * @param {string} newName
     */
    public rename(newName : string) {
        this.name = newName;
    }
}
Parameter["__class"] = "io.apicurio.datamodels.core.models.common.Parameter";
Parameter["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable","io.apicurio.datamodels.core.models.IReferenceNode","io.apicurio.datamodels.core.models.common.INamed"];




